const filterServicePersonsByLocationId = (locationId) => (n) => {
  if (!locationId || (n.locations || []).length < 1) {
    return true;
  }
  return n.locations.filter((l) => l.service_location_id === locationId).length > 0;
};

export default filterServicePersonsByLocationId;
